exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Placeholder */\napp-dashboard, .mat-app-background {\n  height: 100%;\n  width: 100%;\n  background: black;\n  color: white; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/thechairman/Documents/projects/web-app/src/app/app.component.scss
// module id = ../../../../../src/app/app.component.scss
// module chunks = main